import { useAuth } from '@/hooks/use-auth';
import { betaCardBannerCopy } from '@/lib/billing-copy';
import { Button } from '@/components/ui/button';
import { useLocation } from 'wouter';

export function FirmBillingBanners() {
  const { user } = useAuth();
  const [, setLocation] = useLocation();
  const billing = user?.firmBilling;
  if (!billing) return null;

  return (
    <div className="space-y-2 mb-4">
      {billing.locked && (
        <div className="rounded-md border border-red-300 bg-red-50 p-3 text-sm" data-testid="banner-firm-locked">
          This firm is locked after a failed payment. Data is kept. Update the card to restore access.
          <Button className="ml-2" size="sm" onClick={() => setLocation('/settings?tab=billing')}>Update card</Button>
        </div>
      )}
      {billing.showPaymentFailedNotice && !billing.locked && (
        <div className="rounded-md border border-amber-300 bg-amber-50 p-3 text-sm" data-testid="banner-payment-failed">
          The latest payment failed. You have 7 days of access, then the firm will be locked. Data is kept.
        </div>
      )}
      {billing.showBetaCardBanner && (
        <div className="rounded-md border bg-sky-50 p-3 text-sm flex flex-wrap items-center gap-2" data-testid="banner-beta-card">
          <span>{betaCardBannerCopy(billing.firstChargeAt)}</span>
          <Button size="sm" onClick={() => setLocation('/settings?tab=billing')}>Add card</Button>
        </div>
      )}
    </div>
  );
}
